import React from 'react'

export default function Icon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 25" {...props}>
      <g>
        <rect width="18" height="2" x="3" y="12" fill="#21201F" rx="1"></rect>
      </g>
    </svg>
  )
}
